import React, {Component} from 'react';
import { Subscribe } from 'unstated';
import DataContainer from './data/data';

class Footer extends Component {
    render () {
        return (
            <Subscribe to={[DataContainer]}>
                {(DataContainer) => {
                    return (
                        <div className="footer">
                            Inspired by <a href="https://www.reddit.com/r/sports/comments/b4ypio/circular_march_madness_bracket_from_the_round_of/">reddit</a> |
                            Projections from <a href="https://projects.fivethirtyeight.com/2019-march-madness-predictions">538</a> (updated {DataContainer.getDate()}) |
                            ©2019 <a href="http://charleyho.com">charleyho.com</a>
                        </div>
                    );
                }}
            </Subscribe>
        );
    }
}

export default Footer;